// complementary-carousel.js — Matcha Jeans
// Guarda este archivo en /assets/complementary-carousel.js del theme.
// Se carga desde el bloque "Carrusel de complementos" en product.liquid.

(function () {
  // Mapa de nombres de color habituales (ES/EN) → hex, para pintar los swatches.
  var CCW_COLOR_MAP = {
    'negro': '#1c1c1c', 'black': '#1c1c1c',
    'blanco': '#f5f5f0', 'white': '#f5f5f0',
    'crema': '#f0e6d2', 'cream': '#f0e6d2', 'beige': '#e3d5b8',
    'gris': '#9a9a9a', 'grey': '#9a9a9a', 'gray': '#9a9a9a',
    'azul': '#2e4b7a', 'blue': '#2e4b7a', 'navy': '#1c2540', 'marino': '#1c2540',
    'rojo': '#b23b3b', 'red': '#b23b3b',
    'rosa': '#e5a1b8', 'pink': '#e5a1b8',
    'verde': '#4a7a5c', 'green': '#4a7a5c',
    'marron': '#6b4a34', 'marrón': '#6b4a34', 'brown': '#6b4a34',
    'amarillo': '#e0c14a', 'yellow': '#e0c14a',
    'naranja': '#d98237', 'orange': '#d98237',
    'morado': '#7a5aa3', 'purple': '#7a5aa3', 'lila': '#b8a3d9',
    'denim': '#3a5578'
  };

  function colorToHex(name) {
    if (!name) return null;
    var key = name.toString().trim().toLowerCase();
    if (CCW_COLOR_MAP[key]) return CCW_COLOR_MAP[key];
    for (var k in CCW_COLOR_MAP) {
      if (key.indexOf(k) !== -1) return CCW_COLOR_MAP[k];
    }
    return null;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.moneyFormat) {
      return Shopify.formatMoney(cents, window.moneyFormat);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + '€';
  }

  function initSwatches(root) {
    root.querySelectorAll('[data-ccw-swatches]').forEach(function (wrap) {
      wrap.querySelectorAll('[data-ccw-swatch]').forEach(function (swatch) {
        var hex = colorToHex(swatch.getAttribute('data-color-name'));
        if (hex) {
          swatch.style.backgroundColor = hex;
        } else {
          swatch.classList.add('complementary-carousel__swatch--unknown');
        }
        if (swatch.getAttribute('data-available') === 'false') {
          swatch.classList.add('is-unavailable');
        }

        swatch.addEventListener('click', function () {
          wrap.querySelectorAll('[data-ccw-swatch]').forEach(function (s) {
            s.classList.remove('is-selected');
          });
          swatch.classList.add('is-selected');

          var item = wrap.closest('.complementary-carousel__item');
          var addBtn = item.querySelector('[data-ccw-add-to-cart]');
          var priceEl = item.querySelector('[data-ccw-price]');

          addBtn.setAttribute('data-variant-id', swatch.getAttribute('data-variant-id'));

          var price = parseInt(swatch.getAttribute('data-price'), 10);
          var compareAt = parseInt(swatch.getAttribute('data-compare-at-price'), 10);
          if (priceEl) {
            if (compareAt && compareAt > price) {
              priceEl.innerHTML =
                '<span class="complementary-carousel__price--compare">' + formatMoney(compareAt) + '</span>' +
                '<span class="complementary-carousel__price--sale">' + formatMoney(price) + '</span>';
            } else {
              priceEl.innerHTML = '<span>' + formatMoney(price) + '</span>';
            }
          }

          var available = swatch.getAttribute('data-available') === 'true';
          addBtn.disabled = !available;
          var label = addBtn.querySelector('.complementary-carousel__add-label');
          if (label) label.textContent = available ? (addBtn.dataset.defaultLabel || 'Añadir') : 'Agotado';
        });
      });
    });
  }

  function initComplementaryCarousel(root) {
    if (!root || root.dataset.ccwInitialized === 'true') return;
    root.dataset.ccwInitialized = 'true';

    var track = root.querySelector('[data-ccw-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ccw-slide]'));
    var prevBtn = root.querySelector('[data-ccw-prev]');
    var nextBtn = root.querySelector('[data-ccw-next]');
    var dotsWrap = root.querySelector('[data-ccw-dots]');
    if (!track || !slides.length) return;

    initSwatches(root);

    var dots = [];
    slides.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'complementary-carousel__dot';
      dot.setAttribute('aria-label', 'Ir al producto ' + (i + 1));
      dot.addEventListener('click', function () { scrollToSlide(i); });
      dotsWrap.appendChild(dot);
      dots.push(dot);
    });

    function idx() {
      var trackRect = track.getBoundingClientRect();
      var closest = 0, dist = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs(s.getBoundingClientRect().left - trackRect.left);
        if (d < dist) { dist = d; closest = i; }
      });
      return closest;
    }

    function scrollToSlide(i) {
      var slide = slides[Math.max(0, Math.min(i, slides.length - 1))];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }

    function updateControlsVisibility() {
      var needsScroll = track.scrollWidth > track.clientWidth + 4;
      if (prevBtn) prevBtn.hidden = !needsScroll;
      if (nextBtn) nextBtn.hidden = !needsScroll;
      dotsWrap.hidden = !needsScroll || slides.length < 2;
    }

    function updateActiveState() {
      var c = idx();
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === c); });
      if (prevBtn) prevBtn.disabled = c === 0;
      if (nextBtn) nextBtn.disabled = c === slides.length - 1;
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollToSlide(idx() - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollToSlide(idx() + 1); });

    var scrollTimeout;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateActiveState, 80);
    });
    window.addEventListener('resize', function () {
      updateControlsVisibility();
      updateActiveState();
    });
    updateControlsVisibility();
    updateActiveState();

    // Drag con ratón (touch/trackpad ya funcionan de forma nativa)
    var isDown = false, startX = 0, scrollStart = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      isDown = true;
      track.classList.add('is-dragging');
      startX = e.clientX;
      scrollStart = track.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      track.scrollLeft = scrollStart - (e.clientX - startX);
    });
    function stopDrag() { isDown = false; track.classList.remove('is-dragging'); }
    window.addEventListener('pointerup', stopDrag);
    window.addEventListener('pointercancel', stopDrag);

    // Añadir al carrito (AJAX)
    root.querySelectorAll('[data-ccw-add-to-cart]').forEach(function (button) {
      var labelEl = button.querySelector('.complementary-carousel__add-label');
      if (labelEl) button.dataset.defaultLabel = labelEl.textContent;

      button.addEventListener('click', function () {
        if (button.disabled || button.dataset.loading === 'true') return;

        var variantId = button.getAttribute('data-variant-id');
        var originalLabel = labelEl ? labelEl.textContent : '';

        button.dataset.loading = 'true';
        if (labelEl) labelEl.textContent = 'Añadiendo…';

        fetch(window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('No se pudo añadir el producto al carrito');
            return response.json();
          })
          .then(function () {
            if (labelEl) labelEl.textContent = 'Añadido ✓';

            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

            try {
              var drawer = document.querySelector('cart-drawer, [data-cart-drawer], #cart-drawer, #CartDrawer');
              if (drawer) {
                if (typeof drawer.open === 'function') {
                  drawer.open();
                } else {
                  drawer.classList.add('is-open', 'active', 'drawer--open');
                  drawer.setAttribute('open', 'true');
                }
              }
            } catch (err) {
              /* si el theme usa otro sistema de drawer, no rompe el resto del flujo */
            }

            setTimeout(function () {
              if (labelEl) labelEl.textContent = originalLabel;
              button.dataset.loading = 'false';
            }, 1800);
          })
          .catch(function () {
            if (labelEl) labelEl.textContent = 'Error, reintenta';
            setTimeout(function () {
              if (labelEl) labelEl.textContent = originalLabel;
              button.dataset.loading = 'false';
            }, 1800);
          });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-complementary-carousel]').forEach(initComplementaryCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();